import {type ComponentProps, useMemo} from 'react'

interface DangerProps
  extends Omit<ComponentProps<'div'>, 'children' | 'dangerouslySetInnerHTML'> {
  tag?: string
  children?: string
}

/**
 * Dangerous but not stupid.
 * https://github.com/facebook/react/issues/31660
 */
export const Danger = ({tag = 'div', children = '', ...props}: DangerProps) => {
  const Tag = tag as 'div'
  const contentProps = useMemo<ComponentProps<'div'>>(
    () => ({dangerouslySetInnerHTML: {__html: children}}),
    [children],
  )
  return <Tag {...props} {...contentProps} />
}
